// Copyright ID Business Solutions Ltd. 2023

import styled from 'styled-components';

export const FullHeightContent = styled.div`
  height: 100%;
`;
